import React, { useMemo, useRef } from "react"
import InputDatePicker from "../../others/InputDatePicker"
import { ENTITE_TYPE_BUREAU_EXPERT, ENTITE_TYPE_POLICE } from "./Entite"
import { typeNumber } from "../../../utilities/Addons"
import { useSelector } from "react-redux"
import { useTarif } from "../../../hooks/useTarif"

export const PERSONNE_TYPE_CLIENT = 0
export const PERSONNE_TYPE_CONDUCTEUR_LOCATION = 1
export const PERSONNE_TYPE_EXPERT = 2
export const PERSONNE_TYPE_POLICIER = 3
export const PERSONNE_TYPES = [
	[PERSONNE_TYPE_CLIENT, "Client"],
	[PERSONNE_TYPE_EXPERT, "Expert"],
	[PERSONNE_TYPE_POLICIER, "Policier"],
]

export const PERSONNE_APPELLATION = [
	[0, "Madame"],
	[2, "Mademoiselle"],
	[1, "Monsieur"],
]

const Personne = ({
	personne,
	editPersonne = null,
	savePersonne = null,
	showType = true,
}) => {
	const { groups } = useSelector((state) => state.navInfo.login)
	const { prixHoraire } = useTarif()
	const refNom = useRef(null)
	const refPrenom = useRef(null)
	const refAppellation = useRef(null)
	const refTelephone = useRef(null)
	const refEmail = useRef(null)
	const refDateNaissance = useRef(null)
	const refType = useRef(null)

	const showVente = useMemo(() => {
		return personne.type === PERSONNE_TYPE_CLIENT
	}, [personne.type])

	const updateExtraData = (key, value) => {
		let tempExtraData = Object.assign({}, editPersonne.extra_data)
		tempExtraData[key] = value
		if (editPersonne) editPersonne("extra_data", tempExtraData)
	}
	return (
		<>
			{showType && (
				<div className="lab-in full">
					<label>Type</label>
					<select
						ref={refType}
						value={personne.type}
						onChange={(e) =>
							editPersonne("type", parseInt(e.target.value))
						}
						disabled={editPersonne === null}
					>
						{PERSONNE_TYPES.map((p_type) => (
							<option
								key={`select_p_type_${p_type[0]}`}
								value={p_type[0]}
							>
								{p_type[1]}
							</option>
						))}
					</select>
				</div>
			)}
			<div className="row sb full">
				<div className="lab-in w45">
					<label>Appellation</label>
					<select
						ref={refAppellation}
						value={personne.appellation}
						onChange={(e) =>
							editPersonne(
								"appellation",
								parseInt(e.target.value),
							)
						}
						disabled={editPersonne === null}
					>
						{PERSONNE_APPELLATION.map((p_app) => (
							<option
								key={`select_p_app_${p_app[0]}`}
								value={p_app[0]}
							>
								{p_app[1]}
							</option>
						))}
					</select>
				</div>
				<div className="lab-in w45">
					<label>Nom</label>
					<input
						ref={refNom}
						value={personne.nom}
						onChange={(e) => editPersonne("nom", e.target.value)}
						disabled={editPersonne === null}
					/>
				</div>
			</div>
			<div className="row sb full">
				<div className="lab-in w45">
					<label>Prénom</label>
					<input
						ref={refPrenom}
						value={personne.prenom}
						onChange={(e) => editPersonne("prenom", e.target.value)}
						disabled={editPersonne === null}
					/>
				</div>
				<div className="lab-in w45">
					<label>Téléphone</label>
					<input
						ref={refTelephone}
						value={personne.telephone}
						onChange={(e) =>
							editPersonne("telephone", e.target.value)
						}
						disabled={editPersonne === null}
					/>
				</div>
			</div>
			<div className="row sb full">
				<div className="lab-in w45">
					<label>E-mail</label>
					<input
						ref={refEmail}
						value={personne.email}
						onChange={(e) => editPersonne("email", e.target.value)}
						disabled={editPersonne === null}
					/>
				</div>
				<InputDatePicker
					keyName={"date_naissance"}
					inputRef={refDateNaissance}
					value={personne.date_naissance}
					update={editPersonne}
					title={"Date de Naissance"}
					extraClass={"w45"}
					disabled={editPersonne === null}
				/>
			</div>
			{personne.type === PERSONNE_TYPE_POLICIER && (
				<div className="lab-in w45">
					<label>Matricule</label>
					<input
						value={personne.extra_data.matricule}
						onChange={(e) =>
							updateExtraData("matricule", e.target.value)
						}
						disabled={editPersonne === null}
					/>
				</div>
			)}
			{groups.includes("boss") && showVente && (
				<div className="row full" style={{ alignItems: "flex-start" }}>
					<div className="lab-in border-box small">
						<label>Prix vente main d'oeuvre</label>
						<input value={prixHoraire} readOnly={true} />
					</div>
					<div className="lab-in border-box small">
						<label>Rabais vente main d'oeuvre</label>
						<input
							value={personne.extra_data.prix_vente_unitaire_mo}
							onChange={(e) =>
								updateExtraData(
									"prix_vente_unitaire_mo",
									e.target.value,
								)
							}
							onKeyDown={(e) => typeNumber(e)}
							disabled={editPersonne === null}
						/>
					</div>
				</div>
			)}
			{savePersonne && (
				<button
					type={"button"}
					className={"norm-btn2 mt-20"}
					onClick={savePersonne}
				>
					Sauvegarder
				</button>
			)}
		</>
	)
}

export default Personne

export const getPersonneType = (entiteType) => {
	switch (entiteType) {
		case ENTITE_TYPE_POLICE:
			return PERSONNE_TYPE_POLICIER
		case ENTITE_TYPE_BUREAU_EXPERT:
			return PERSONNE_TYPE_EXPERT
		default:
			return 0
	}
}
